<template>
  <div class="operation-table-wrapper">
    <b-table
    :items="items"
    :fields="fields.filter((each) => each.selected)"
    :hover="true"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :per-page="0"
    :current-page="currentPage"
    show-empty
    label-sort-asc=""
    label-sort-desc=""
    label-sort-clear=""
    sort-icon-right
    :no-border-collapse="true"
    :tbody-tr-class="rowClass"
    @row-clicked="onRowClicked"
    responsive="lg"
    :thead-class="`table-thead text-center bg-transparent ${theadClass}`"
    :tbody-class="`table-tbody text-center ${tbodyClass}`"
    ref="selectableTable"
    info="true"
    class="new-theme-custom-table"
  >
    <template #empty> {{ $t("empty-row") }} </template>
    <template #head(id)="data">
      <span v-if="data">#</span>
    </template>
    <template #head(details)="data">
      <span v-if="data"
        ><img
          :src="require('@/assets/images/icons/Expand-all.svg')"
          alt="arrow"
      /></span>
    </template>

    <template #cell(id)="{ item }">
      <a
        v-if="getRowDetailHref"
        :href="rowDetailHref(item)"
        target="_blank"
        rel="noopener noreferrer"
        class="text-body text-decoration-none"
        :aria-label="$t('reservation-details')"
      >
        <span class="operation-table-id-text">{{ item.id }}</span>
      </a>
      <span v-else>{{ item.id }}</span>
    </template>

    <template #cell(balance)="{ item }">
      <div>
        <span v-if="item?.paidAmount">{{ +item.paidAmount.toFixed(2) }}</span>
        <span v-else>0</span>
        <span>/</span>
        <span v-if="item?.price">{{ item.price }}</span>
        <span v-else>0</span>
      </div>
    </template>
    <template #cell(category)="{ item }">
      <span>{{ item?.category }}</span>
    </template>
    <template #cell(client)="{ item }">
      <span>{{ item?.client }}</span>
    </template>
    <template #cell(product)="{ item }">
      <span>{{ item?.product }}</span>
    </template>
    <template #cell(branch)="{ item }">
      <span>{{ item?.branch }}</span>
    </template>
    <template #cell(finalTotalPriceUntaxed)="{ item }">
      <span>{{ formattedAmount(item?.finalTotalPriceUntaxed) }}</span>
    </template>
    <template #cell(finalPriceIncludingTax)="{ item }">
      <span>{{ formattedAmount(item?.finalPriceIncludingTax) }}</span>
    </template>
    <template #cell(details)="data">
      <div
        class="operation-table-container__action operation-table-interactive-cell operation-table-details-cell"
      >
        <img
          v-if="data?.item?.trips?.length && false"
          :class="[
            { 'rotate-180': data.detailsShowing },
            { 'rotate-180-reverse': !data.detailsShowing },
          ]"
          :src="require('@/assets/images/icons/arrow-down.svg')"
          alt="arrow"
          @click.stop="getTrips(data)"
        />
        <div v-else class="no-arrows"></div>
        <b-dropdown
          :id="'reservation-dropdown-' + (data.item.id ?? data.index)"
          variant="transparent"
          class="reservation-dropdown"
          boundary="viewport"
          dropleft
          menu-class="operation-table-reservation-dropdown-menu"
          @show="onShow(data.item)"
          @hide="onHide"
        >
        <div
        v-if="loading"
          class="d-flex flex-column justify-content-center delete-edit-model"
        >
        <base-spinner />
        </div>
          <div
            v-else
            class="d-flex flex-column justify-content-center delete-edit-model"
          >
            <div
              v-if="isDisabledEdit(data?.item)"
              class="d-flex justify-content-center delete-edit-model-text"
              id="reservation_Edit_button"
              @mouseenter="EditHovered = true"
              @mouseleave="EditHovered = false"
              @click.stop="moveToEdit(data.item)"
            >
              <img
                :src="
                  EditHovered
                    ? require('@/assets/images/icons/pincle-edit.svg')
                    : require('@/assets/images/icons/pincle-edit.svg')
                "
                alt="edit"
                width="13"
              />
              <p class="text-center my-2 mx-3">{{ $t("edit") }}</p>
            </div>
            <div
              v-if="data?.item?.allowUpdate && !hasPendingDiscountWorkflow "
              class="d-flex justify-content-center delete-edit-model-text"
              id="reservation_Edit_button"
              @mouseenter="EditHovered = true"
              @mouseleave="EditHovered = false"
              @click.stop="moveToUpdate(data.item)"
            >
              <p class="text-center my-2 mx-3">{{ $t("update") }}</p>
            </div>
            <hr class="my-0" v-if="!data?.item?.trips?.length && data.item.reservation_status !== 'cancelled'" />
            <div
              v-if="data?.item?.reservation_status !== 'cancelled' && !hasPendingDiscountWorkflow "
              class="d-flex justify-content-center delete-edit-model-text"
              id="reservation_change_status_button"
              @click.stop="changeStatus(data.item)"
            >
              <p class="text-center my-2 mx-3">{{ $t("convert") }}</p> 
            </div>
            <hr class="my-0"/>
            <div
              v-if="data?.item?.reservationCategoryType !== 'Hajj'"
              class="d-flex justify-content-center delete-edit-model-text"
              id="reservation_duplicate_button"
              @click.stop="redirectNewReservation((data.item.type).toLocaleLowerCase(), data?.item?.id)"
            >
              <p class="text-center my-2 mx-3">{{ $t("duplicate") }}</p>
            </div>
            <ChangeStatusModel
              @refreshData="$emit('search')"
              :id="data.item.id"
              :status="data.item.reservation_status"
              :paymentMethod="data.item.clientPaymentMethod"
            />
          </div>
        </b-dropdown>
      </div>
    </template>
    <template #row-details="data">
      <base-spinner v-if="trips_loading_index === data.index" />
      <div v-else>
        <div
          class="trips-collapse"
          @click="moveToOperation(data)"
          v-for="(trip, index) in data.item.trips"
          :key="index"
        >
          <div>
            <div class="d-flex justify-content-evenly mt-2">
              <div class="col-2 text-start">
                <div class="mb-2">
                  <img
                    :src="require('@/assets/images/icons/location-icon.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span v-if="trip.startLocation" class="trips-titles">
                    {{ $t("from") }} {{ trip?.startLocation?.name }}
                  </span>
                </div>
                <div>
                  <img
                    :src="require('@/assets/images/icons/clock-icon.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span class="trips-titles">{{
                    trip.scheduledStartDate
                      ? formatDate(trip.scheduledStartDate)
                      : ""
                  }}</span>
                  <span class="mx-1">{{
                    trip.scheduledStartTime
                      ? formatTime(trip.scheduledStartTime)
                      : ""
                  }}</span>
                </div>
              </div>
              <div class="col-2 text-start">
                <div class="mb-2">
                  <img
                    :src="require('@/assets/images/icons/location-icon.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span v-if="trip.endLocation" class="trips-titles">
                    {{ $t("to") }} {{ trip?.endLocation?.name }}
                  </span>
                </div>
                <div>
                  <img
                    :src="require('@/assets/images/icons/clock-icon.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span class="trips-titles">{{
                    trip.scheduledEndDate
                      ? formatDate(trip.scheduledEndDate)
                      : ""
                  }}</span>
                  <span class="mx-1">{{
                    trip.scheduledEndTime
                      ? formatTime(trip.scheduledEndTime)
                      : ""
                  }}</span>
                </div>
              </div>
              <div class="col-2">
                <div v-if="trip.vehicle" class="mb-2">
                  <img
                    :src="require('@/assets/images/icons/small-truck.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span class="trips-titles">
                    {{
                      isLangRtl
                        ? trip?.vehicle?.make?.arabicName
                        : trip?.vehicle?.make?.name || ""
                    }}
                  </span>
                </div>
                <div v-if="trip.vehicle">
                  <span class="trips-titles">
                    {{
                      isLangRtl
                        ? trip?.vehicle?.category?.arabicName
                        : trip?.vehicle?.category?.name || ""
                    }}
                  </span>
                </div>
              </div>
              <div class="col-2">
                <div v-if="trip.vehicle" class="mb-2">
                  <span class="trips-titles">
                    {{
                      isLangRtl
                        ? trip?.vehicle?.subCategory?.arabicName
                        : trip?.vehicle?.subCategory?.name || ""
                    }}
                  </span>
                </div>
                <div v-if="trip.vehicle">
                  <span class="trips-titles">{{
                    trip?.vehicle?.plateNumber
                  }}</span>
                </div>
              </div>
              <div class="col-2">
                <div v-if="trip.driver">
                  <img
                    :src="require('@/assets/images/icons/small-face.svg')"
                    alt=""
                    class="mx-2"
                  />
                  <span class="trips-titles">
                    {{
                      isLangRtl
                        ? trip?.driver?.arabicName
                        : trip?.driver?.name || ""
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <p>{{ data.item.isActive }}</p>
        </div>
      </div>
    </template>

    <template #cell(collapse)="row">
      <b-button v-b-toggle="'collapse-' + row.index">
        <span v-if="row.showData" class="when-open">
          {{ $t("close") }}
        </span>
        <span v-else class="when-closed"> {{ $t("open") }} </span>
        {{ $t("my-collapse") }}
      </b-button>
      <b-collapse :id="'collapse-' + row.index" v-if="row.showData">
        <p>fffffff</p>
      </b-collapse>
    </template>

    <template #cell(type)="data">
      <div>
        {{ typeOptions?.find((each) => each.value === data.item.type)?.text }}
      </div>
    </template>
    <template #cell(receiptStatus)="data">
      <div class="operation-table-container__action operation-table-interactive-cell d-flex align-items-center justify-content-around">
        <b-button
            :class="[
              data.item.receiptStatus === 'awaiting-invoice'
                ? 'Awaiting invoice'
                : data.item.receiptStatus === 'partially-invoice'
                ? 'Partially invoice'
                : data.item.receiptStatus === 'fully-invoice'
                ? 'Fully invoice'
                : '',
              'reservation_status-btn mx-3',
            ]"
          >
            {{
              receiptStatusOptions?.find(
                (each) => each.value === data.item.receiptStatus
              )?.text
            }}
          </b-button>
      </div>
    </template>
    <template #cell(reservation_status)="data">
      <div
        class="operation-table-container__action operation-table-interactive-cell d-flex align-items-center justify-content-around"
      >
        <div class="not-assigned-content">
          <b-button
            :class="[
              data.item.reservation_status === 'sales-order'
                ? 'Sales-order'
                : data.item.reservation_status === 'draft-sales-order'
                ? 'Draft-sales-order'
                : data.item.reservation_status === 'quotation'
                ? 'Quotation'
                : data.item.reservation_status === 'cancelled'
                ? 'cancelled'
                : data.item.reservation_status === 'rescheduled'
                ? 'rescheduled'
                : data.item.reservation_status === 'waiting-for-approval'
                ? 'waiting-for-approval'
                : '',
              'reservation_status-btn mx-3',
            ]"
          >
            {{
              reservationStatusOptions?.find(
                (each) => each.value === data.item.reservation_status
              )?.text
            }}
          </b-button>
        </div>
      </div>
    </template>
    </b-table>
  </div>
</template>

<script>
import moment from "moment";
import ChangeStatusModel from "@/components/Operations/Details/changeStatusModel.vue";
import TripService from "@/services/trip.service";
import WorkflowInstanceService from "@/services/workflow-instance.service";

export default {
  props: [
    "tbodyClass",
    "theadClass",
    "items",
    "fields",
    "currentPage",
    "sortByProp",
    "sortDescProp",
    "typeOptions",
    "reservationStatusOptions",
    "receiptStatusOptions",
    "getRowDetailHref",
  ],
  emits: ["changeParentSorting", "search"],
  components: { ChangeStatusModel },
  data() {
    return {
      EditHovered: false,
      sortBy: "",
      sortDesc: false,
      trips_loading_index: null,
      workflowItemCount: 0,
      loading:false
    };
  },
  methods: {
    onShow(item){
      this.getPendingDiscountWorkflowCount(item.id)
    },
    onHide(){
      this.workflowItemCount= 0
    },
    rowDetailHref(item) {
      if (!this.getRowDetailHref || !item?.id) return "#";
      const href = this.getRowDetailHref(item);
      return href || "#";
    },
    rowClass(item, type) {
      if (type !== "row") return "trips-collapse-section";
      if (this.getRowDetailHref) return "operation-table-data-row";
    },
    onRowClicked(item, index, event) {
      if (!this.getRowDetailHref || !item?.id) return;
      const href = this.getRowDetailHref(item);
      if (!href || href === "#") return;
      window.open(href, "_blank", "noopener,noreferrer");
    },
    async getTrips(data) {
      if (data?.item?.trips?.length && !this.trips_loading_index) {
        data.toggleDetails();
        if (!data.item.trips[0].scheduledEndDate) {
          let trips = [];
          this.trips_loading_index = data.index;
          await Promise.all(
            data?.item.trips?.map(async (trip) => {
              const res = await TripService.get(trip._id, {
                select:
                  "_id,startLocation.name,scheduledStartTime,scheduledEndTime,endLocation.name,vehicle.make.name,vehicle.make.arabicName,vehicle.category.name,vehicle.category.arabicName,vehicle.subCategory.name,vehicle.subCategory.arabicName,vehicle.plateNumber,driver.name,driver.arabicName,scheduledStartDate,scheduledEndDate",
              });
              trips.push(res);
            })
          );
          this.items[data.index].trips = trips;
          this.trips_loading_index = null;
        }
      }
    },
    getPendingDiscountWorkflowCount(id){
      this.loading = true
      const params = new URLSearchParams();
      params.append("data.salesOrderID", id);
      params.append("status", "pending");
      params.append("entity","Sales Order")
      params.append("action","Apply discount")
      WorkflowInstanceService.search(params).then((response) => {
        this.workflowItemCount=response?.total
      }).catch((error) => {
        this.error = error.message;
      }).finally(()=>{
        this.loading = false
      });
    },
    // TODO: to be deleted once we confirm that from the business side
    // canUpdate(data) {
    //   return (
    //     data?.reservation_status === "sales-order" &&
    //     data.type !== "Shift-Recurrence" &&
    //     !this.$store.getters["enums/is_not_permitted"]("generateReservation") &&
    //     !this.$store.getters["enums/is_not_permitted"]("updateReservation") &&
    //     data.services?.find((service) => this.isServiceCanUpdate(service, data))
    //   );
    // },
    // isServiceCanUpdate(service, data) {
    //   let a = moment(),
    //     b = moment();
    //   if (!service.serviceQuantity) {
    //     return false;
    //   } else if (data.type === "Recurrence" && service?.trips?.length) {
    //     if (
    //       service.trips.find((each) => {
    //         if (each?.scheduledStartDate && each?.scheduledStartTime) {
    //           let a = moment(),
    //             b = moment();
    //           const start_time_parts = each.scheduledStartTime.split(":");
    //           a = moment(each.scheduledStartDate)
    //             .set("hour", start_time_parts[0])
    //             .set("minute", start_time_parts[1])
    //             .set("seconds", 0);
    //           const minutes = a.diff(b, "minutes");
    //           // more than 24 hours
    //           return minutes > 1440 ? true : false;
    //         }
    //       })
    //     )
    //       return true;
    //     else return false;
    //   } else if (service?.fromDate && service?.fromTime) {
    //     const from_time_parts = service.fromTime.split(":");

    //     a = moment(service.fromDate)
    //       .set("hour", from_time_parts[0])
    //       .set("minute", from_time_parts[1])
    //       .set("seconds", 0);
    //     const minutes = a.diff(b, "minutes");
    //     return minutes > 0 ? true : false;
    //   } else return true;
    // },
    moveToEdit(data) {
      const isHajj = data?.reservationCategoryType === "Hajj";
      let path = isHajj
        ? `/hajj/sales-order/edit/form/${data?.id}`
        : `/reservation/edit/form/${data?.id}`;
      const query = {};
      if (data?.type) query["type"] = data.type.toLocaleLowerCase();
      if (this.$route?.query?.clientID)
        query["clientID"] = this.$route?.query?.clientID;
      const routeData = this.$router.resolve({ path, query });
      window.open(routeData.href, '_blank');
    },
    moveToUpdate(data) {
      const isHajj = data?.reservationCategoryType === "Hajj";
      let path = isHajj
        ? `/hajj/sales-order/update/form/${data?.id}`
        : `/reservation/update/form/${data?.id}`;
      const query = {};
      if (data?.type) query["type"] = data.type.toLocaleLowerCase();
      if (this.$route?.query?.clientID)
        query["clientID"] = this.$route?.query?.clientID;
      this.$router.push({ path, query }).catch(() => {})
    },
    changeStatus(data) {
      if (
        !this.$store.getters["enums/is_not_permitted"](
          "changeReservationStatus"
        )
      )
        this.$bvModal.show(
          `change-trip-status-model${data?.id ? `-${data.id}` : ""}`
        );
    },
    moveToOperation(item) {
      this.$router.push(`/reservation/${item.item.id}`).catch(() => {});
    },
    formatDate(date) {
      return moment(date).locale("en").format("DD-MM-YYYY");
    },
    formatTime(date) {
      return moment(date).locale("en").utcOffset(0).format("HH:mm");
    },
    redirectNewReservation(type, id) { 
      if (!this.$store.getters["enums/is_not_permitted"]("generateReservation")) {
        let path =  `/reservation/add/form?type=${type}&duplicateId=${id}`;
        if (this.$route?.query?.clientID) {
          path += `&clientID=${this.$route?.query?.clientID}`
        }
        const routeData = this.$router.resolve(path);
        window.open(routeData.href, '_blank');
      }
    },
    isDisabledEdit(data) {
      if(this.hasPendingDiscountWorkflow){
        return false
      }
      if (data?.paymentLink && data?.reservation_status === 'quotation') {
        return data?.reservation_status === 'quotation' &&
          (data?.clientPaymentMethod === 'Credit' ||
            (data?.clientPaymentMethod === 'Debit' &&
              data?.paymentLink && this.isExpired(data?.paymentLinkExpiryDate)));
      } else {
        return data?.reservation_status === 'quotation'
      }

    },
  },
  computed:{
    hasPendingDiscountWorkflow(){
      return this.workflowItemCount > 0
    }
  },
  watch: {
    sortBy(val) {
      this.$emit("changeParentSorting", val, this.sortDesc);
    },
    sortDesc(val) {
      this.$emit("changeParentSorting", this.sortBy, val);
    },
    sortByProp(val) {
      this.sortBy = val;
    },
    sortDescProp(val) {
      this.sortDesc = val;
    },
  },
};
</script>

<style scoped>
.operation-table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.operation-table-wrapper .new-theme-custom-table {
  min-width: 720px;
}

.operation-table-wrapper ::v-deep tr.operation-table-data-row {
  cursor: pointer;
}
</style>